export const accountTypeMap = {
  'select-beneficiaryroth': ['Beneficiary Roth IRA', 'invest-roth-ira'],
  'select-beneficiary': ['Beneficiary IRA', 'invest-ira-application'],
  'select-coverdell': ['Coverdell', 'coverdell-application'],
  'select-trust': ['Trust', 'invest-trust-application']
};
